import { useState } from 'react';
import DetailHeader from '../components/DetailHeader';
import DetailControls from '../components/DetailControls';
import ServiceBusSummaryTile from '../components/tiles/ServiceBusSummaryTile';
import DlqActionsPanel from '../components/DlqActionsPanel';
import type { Env } from '../types';

// No period selector — SB counts are a real-time snapshot (ARM
// countDetails), not a time-windowed aggregation, so the dropdown
// wouldn't do anything. The refresh button still applies.
export default function EnvServiceBusDetail({ env }: { env: Env }) {
  const [refreshToken, setRefreshToken] = useState(0);
  const bump = () => setRefreshToken((t) => t + 1);

  return (
    <div className="page">
      <DetailHeader
        env={env}
        title="Service Bus"
        subtitle="Queue, topic and subscription counts. Dead-lettered messages can be resubmitted to their source from the reconciliation panel."
      />
      <DetailControls
        windowHours={24}
        onWindowChange={() => undefined}
        onRefresh={bump}
        hideWindow
      />
      <section className="tile-grid tile-grid-wide">
        <ServiceBusSummaryTile env={env} refreshToken={refreshToken} />
        <DlqActionsPanel env={env} refreshToken={refreshToken} onResubmitted={bump} />
      </section>
    </div>
  );
}
